import Sidebar from "./components/sidebar/Sidebar";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from "./pages/productList/ProductList";
import Product from "./pages/product/Product";
import ProductColor from "./pages/productColor/ProductColor";
import ProductGallery from "./pages/productGallery/ProductGallery";
import NewProduct from "./pages/newProduct/NewProduct";
import WarrantyList from "./pages/warrantyList/WarrantyList";
import ReturnList from "./pages/warrantyList/ReturnList";
import StockList from "./pages/warrantyList/StockList";
import NewWarranty from "./pages/newWarranty/NewWarranty";
import NewAdmin from "./pages/newAdmin/NewAdmin";
import NewAffiliate from "./pages/newAffiliate/NewAffiliate";
import OrderList from "./pages/orderList/OrderList";
import AffiliateList from "./pages/affiliateList/AffiliateList";
import History from "./pages/history/History";
import DepositHistory from "./pages/history/DepositHistory";
import DepositList from "./pages/depositList/DepositList";
import EcommerceList from "./pages/ecommerceList/EcommerceList";
import SalesReport from "./pages/salesReport/SalesReport";
import Report from "./pages/report/Reporting";
import Login from "./pages/login/Login";
import Pos from "./pages/pos/pos";
import Outlet from "./pages/outlet/Outlet";
import { useSelector } from "react-redux";
import TransactionList from "./pages/transaction/TransactionList";
import ProductReport from "./pages/productReport/ProductReport";
import ProductStatus from "./pages/productStatus/ProductStatus";
import AffiliateReport from "./pages/affiliateReport/AffiliateReport";
import Checklist from "./pages/checkList/CheckList";
import Campaign from "./pages/campaignList/Campaign";
import Transfer from "./pages/transfer/Transfer";
import DeliveryOrder from "./pages/deliveryOrderList/DeliveryOrder";
import DeliveryOrderUpload from "./pages/deliveryOrderUpload/DeliveryOrderUpload";
import CompleteDepositList from "./pages/completeDepositList/CompleteDepositList";
import NewBrand from "./pages/newBrand/newBrand";
import Brand from "./pages/brand/Brand";
import NewCategory from "./pages/newCategory/newCategory";
import Category from "./pages/category/Category";
import TradeIn from "./pages/pos/tradein";
import TradeInList from "./pages/orderList/TradeIn";
import Journal from "./pages/pos/journal";
import Supplier from "./pages/pos/supplier";
import JournalList from "./pages/orderList/Journal";
import SupplierList from "./pages/orderList/Supplier";
import StatementList from "./pages/orderList/StatementList";
import EditOrder from "./pages/pos/editOrder";
import NewVehicle from "./pages/vehicle/vehicle";
import VehicleList from "./pages/vehicle/VehicleList";
import Assets from "./pages/pos/assets";
import NewSupplier from "./pages/newUser/NewSupplier";
import Journals from "./pages/history/Journal";
import ModelReport from "./pages/productReport/ModelReport";
import NewStaff from "./pages/newUser/NewStaff";
import NewDealer from "./pages/newUser/NewDealer";
import CommissionList from "./pages/commissionList/CommissionList";

function App() {
    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin : null
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    return (
        <div className="globalContainer">
            <Router>
                <Switch>
                    <Route exact path="/">
                        {                        admin ||
                        superadmin ||
                        staff ||
                        manager ||
                        accountant ||
                        outright ? (
                            <>
                                <div className="container">
                                    <Sidebar />
                                    <OrderList />
                                </div>
                            </>
                        ) : (
                            <Login />
                        )}
                    </Route>
                    {(staff ||
                        manager ||
                        admin ||
                        superadmin ||
                        accountant ||
                        outright) && (
                        <>
                            <div className="container">
                                <Sidebar />
                                <Route path="/orders">
                                    <OrderList />
                                </Route>
                                <Route path="/statements">
                                    <StatementList />
                                </Route>
                                <Route path="/tradeinlist">
                                    <TradeInList />
                                </Route>
                                <Route path="/supplierlist">
                                    <SupplierList />
                                </Route>
                                <Route path="/expenseslist">
                                    <JournalList />
                                </Route>
                                <Route path="/completedeposit">
                                    <CompleteDepositList />
                                </Route>
                                <Route path="/history">
                                    <History />
                                </Route>
                                <Route path="/installments">
                                    <DepositHistory />
                                </Route>
                                <Route path="/journals">
                                    <Journals />
                                </Route>
                                <Route path="/deposits">
                                    <DepositList />
                                </Route>
                                <Route path="/completeorder">
                                    <EcommerceList />
                                </Route>
                                {(staff ||
                                    manager ||
                                    admin ||
                                    superadmin ||
                                    outright) && (
                                    <>
                                        <Route exact path="/pos">
                                            <Pos />
                                        </Route>
                                        <Route exact path="/tradein">
                                            <TradeIn />
                                        </Route>
                                        <Route exact path="/operatingexpenses">
                                            <Journal />
                                        </Route>
                                        <Route exact path="/assets">
                                            <Assets />
                                        </Route>
                                        <Route exact path="/supplier">
                                            <Supplier />
                                        </Route>
                                        <Route path="/newUser">
                                            <NewUser />
                                        </Route>
                                        <Route path="/newsupplier">
                                            <NewSupplier />
                                        </Route>
                                        <Route path="/deliveryorders">
                                            <DeliveryOrder />
                                        </Route>
                                        {(manager ||
                                            admin ||
                                            superadmin ||
                                            outright) && (
                                            <>
                                                <Route path="/warranties">
                                                    <WarrantyList />
                                                </Route>
                                                <Route path="/returns">
                                                    <ReturnList />
                                                </Route>
                                                <Route path="/stocks">
                                                    <StockList />
                                                </Route>
                                                <Route path="/checklist">
                                                    <Checklist />
                                                </Route>
                                                <Route path="/transfer">
                                                    <Transfer />
                                                </Route>
                                                <Route path="/commissions">
                                                                    <CommissionList />
                                                                </Route>
                                                {(admin || outright) && (
                                                    <>
                                                        <Route path="/products">
                                                            <ProductList />
                                                        </Route>
                                                        <Route path="/newproduct">
                                                            <NewProduct />
                                                        </Route>

                                                        <Route path="/affiliates">
                                                            <AffiliateList />
                                                        </Route>

                                                        {superadmin && (
                                                            <>
                                                                <Route path="/outlets">
                                                                    <Outlet />
                                                                </Route>
                                                                <Route path="/newwarranty">
                                                                    <NewWarranty />
                                                                </Route>
                                                                <Route path="/transactions">
                                                                    <TransactionList />
                                                                </Route>

                                                                <Route path="/newadmin">
                                                                    <NewAdmin />
                                                                </Route>
                                                                <Route path="/newbrand">
                                                                    <NewBrand />
                                                                </Route>
                                                                <Route path="/newvehicle">
                                                                    <NewVehicle />
                                                                </Route>
                                                                <Route path="/newcategory">
                                                                    <NewCategory />
                                                                </Route>

                                                                <Route path="/brands">
                                                                    <Brand />
                                                                </Route>
                                                                <Route path="/vehicles">
                                                                    <VehicleList />
                                                                </Route>
                                                                <Route path="/categories">
                                                                    <Category />
                                                                </Route>
                                                                <Route path="/campaigns">
                                                                    <Campaign />
                                                                </Route>

                                                                <Route path="/productgallery/:productId">
                                                                    <ProductGallery />
                                                                </Route>
                                                                <Route path="/productstatus/:productId">
                                                                    <ProductStatus />
                                                                </Route>
                                                                <Route path="/product/:productId">
                                                                    <Product />
                                                                </Route>

                                                                <Route path="/order/:productId">
                                                                    <EditOrder />
                                                                </Route>
                                                                <Route path="/deliveryorderupload/:deliveryOrderId">
                                                                    <DeliveryOrderUpload />
                                                                </Route>
                                                                <Route path="/salesreport">
                                                                    <SalesReport />
                                                                </Route>

                                                                <Route path="/productreport">
                                                                    <ProductReport />
                                                                </Route>
                                                                <Route path="/modelreport">
                                                                    <ModelReport />
                                                                </Route>
                                                                <Route path="/productcolor/:productId">
                                                                    <ProductColor />
                                                                </Route>

                                                                <Route path="/affiliatereport">
                                                                    <AffiliateReport />
                                                                </Route>
                                                            </>
                                                        )}

                                                        {(superadmin ||
                                                            outright) && (
                                                            <>
                                                                <Route path="/users">
                                                                    <User />
                                                                </Route>

                                                                <Route path="/report">
                                                                    <Report />
                                                                </Route>
                                                                <Route path="/newaffiliate">
                                                                    <NewAffiliate />
                                                                </Route>
                                                      
                                                                <Route path="/newstaff">
                                                                    <NewStaff />
                                                                </Route>
                                                            </>
                                                        )}
                                                        {superadmin && (
                                                            <>
                                                                <Route path="/newdealer">
                                                                    <NewDealer />
                                                                </Route>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </Switch>
            </Router>
        </div>
    );
}

export default App;
